module.exports = __webpack_public_path__ + "img/add.4e27ad83.svg";